// Until Sep 2026 the Amplify session cookies were scoped to the parent domain so admin and
// booking shared one login. They are now host-scoped, but the old parent-domain cookies
// (~7 KB per Cognito client, 365-day expiry) stay in every browser and push the Cookie
// header past what the noro.co apex host accepts. Expire them once on startup.
// ponytail: remove after Sep 2027, when every legacy cookie has expired on its own.
const LEGACY_SHARED_COOKIE_DOMAINS = ['.noro.co', '.sharedstudios.com'];

export const expireLegacySharedLoginCookies = () => {
    const legacyDomain = LEGACY_SHARED_COOKIE_DOMAINS.find((domain) => window.location.hostname.endsWith(domain));
    if (!legacyDomain) return;

    document.cookie.split('; ').forEach((cookie) => {
        const name = cookie.split('=')[0];
        const isAmplifyCookie =
            name.startsWith('CognitoIdentityServiceProvider.') || name === 'amplify-signin-with-hostedUI';
        if (isAmplifyCookie) {
            document.cookie = `${name}=; domain=${legacyDomain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        }
    });
};
